module.exports = __webpack_public_path__ + "img/sleeve cuff length.e79d4733.png";